"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Player = void 0;
var Player = (function () {
    function Player() {
        this.id = '';
        this.videoUrl = '';
    }
    Player.prototype.setPlayerInstance = function (playerInstance) {
        this.playerInstance = playerInstance;
    };
    Player.prototype.getPlayerInstance = function () {
        return this.playerInstance;
    };
    Player.prototype.getPlaybackRate = function () {
        return this.playerInstance.playbackRate;
    };
    Player.prototype.setPlayerId = function (playerId) {
        this.id = playerId;
    };
    Player.prototype.getPlayerId = function () {
        return this.id;
    };
    Player.prototype.setVideoUrl = function (videoUrl) {
        this.videoUrl = videoUrl;
    };
    Player.prototype.getVideoUrl = function () {
        return this.videoUrl;
    };
    return Player;
}());
exports.Player = Player;
//# sourceMappingURL=Player.js.map